export const setAudioCurrentTime = (audio: HTMLAudioElement, currentTime: number) => {
  if (isNaN(audio.duration)) {
    return;
  }

  audio.currentTime = currentTime;
};
